// extracted by mini-css-extract-plugin
export default {"projectCard":"Projects_projectCard__dBATV","cardImage":"Projects_cardImage__zrnOp","projects":"Projects_projects__TRkZn"};